import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from 'src/components/Dashboard/Views/Login/Login.vue'
import ForgotPassword from 'src/components/Dashboard/Views/ForgotPassword/ForgotPassword.vue'
import RenewPassword from 'src/components/Dashboard/Views/RenewPassword/RenewPassword.vue'
import DashboardLayout from 'src/components/Dashboard/Layout/DashboardLayout/DashboardLayout.vue'
import User from 'src/components/Dashboard/Views/ProfilUtilisateur/ProfilUtilisateur.vue'
import AccesUtilisateur from 'src/components/Dashboard/Views/AccesUtilisateur/AccesUtilisateur.vue'
import AdminUtilisateurs from 'src/components/Dashboard/Views/Admin/ListeUtilisateurs/ListeUtilisateurs.vue'
import AdminListeStructures from 'src/components/Dashboard/Views/Admin/ListeStructures/ListeStructures.vue'
import AdminStructure from '../components/Dashboard/Views/Admin/Structure/Structure.vue';
import CreerUtilisateur from '../components/Dashboard/Views/CreerUtilisateur/CreerUtilisateur.vue';
import AuthorizeUser from '../components/Dashboard/Views/Admin/AuthorizeUser/AuthorizeUser.vue';
import AdminListeUtilisateurs from 'src/components/Dashboard/Views/Admin/AdminListeUtilisateurs/AdminListeUtilisateurs.vue'
import AdminListeLogs from 'src/components/Dashboard/Views/Admin/ListeLogs/ListeLogs.vue'
import CreateAccount from 'src/components/Dashboard/Views/CreateAccount/CreateAccount.vue'

Vue.use(VueRouter)

const router = new VueRouter({
    routes: [
        {
            path: '/',
            redirect: Login
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/forgotPassword',
            name: 'ForgotPassword',
            component: ForgotPassword
        },
        {
            path: '/renewPassword/:token',
            name: 'RenewPassword',
            component: RenewPassword
        },
        {
            path: '/createAccount',
            name: 'CreateAccount',
            component: CreateAccount
        },
        {
            path: '/pages',
            component: DashboardLayout,
            meta: { requiresAuth: true },
            children: [
                {
                    path: 'user/me',
                    name: 'User',
                    component: User,
                    meta: {
                        text: 'Utilisateur'
                    }
                },
                {
                    path: 'user/acces',
                    name: 'UserAcces',
                    component: AccesUtilisateur,
                    meta: {
                        text: 'Accès'
                    }
                },
                {
                    path: 'admin/autorisation',
                    name: 'AuthorizeUser',
                    component: AuthorizeUser,
                    meta: {
                      text: 'Autorisation'
                    }
                },
                {
                    path: 'admin/user/structure/:idStructure',
                    name: 'AdminUserStructure',
                    component: AdminUtilisateurs,
                    meta: {
                        breadCrumbs: [{
                            to: '/pages/admin/listeStructures',
                            text: 'Structures'
                        },{
                            to: '/pages/admin/structure/detail/:structureId',
                            text: ':structureNom'
                        }],
                        text: 'Utilisateurs'
                    }
                },

                {
                    path: 'admin/detail/user/:idUser',
                    name: 'AdminUserProfil',
                    component: User,
                    meta: {
                        breadCrumbs: [{
                            to: '/pages/admin/listeUtilisateurs',
                            text: 'Utilisateurs'
                        }],
                        text: ':userNom'
                    }
                },
                {
                    path: 'admin/user/detail/:idUser',
                    name: 'AdminUser',
                    component: User,
                    meta: {
                        breadCrumbs: [{
                            to: '/pages/admin/listeStructures',
                            text: 'Structures'
                        },{
                            to: '/pages/admin/structure/detail/:structureId',
                            text: ':structureNom'
                        },{
                            to: '/pages/admin/user/structure/:structureId',
                            text: 'Utilisateurs'
                        }],
                        text: ':userNom'
                    }
                },
                {
                    path: 'admin/listeStructures',
                    name: 'AdminListeStructures',
                    component: AdminListeStructures,
                    meta: {
                        text: 'Structures'
                    }
                },
                {
                    path: 'admin/structure',
                    name: 'AdminStructure',
                    component: AdminStructure,
                    meta: {
                        breadCrumbs: [{
                            to: '/pages/admin/listeStructures',
                            text: 'Structures'
                        }],
                        text: 'Ajouter'
                    }
                },
                {
                    path: 'admin/structure/detail/:idStructure',
                    name: 'AdminDetailstructure',
                    component: AdminStructure,
                    meta: {
                        breadCrumbs: [{
                            to: '/pages/admin/listeStructures',
                            text: 'Structures'
                        }],
                        text: ':structureNom'
                    }
                },
                {
                    path: 'admin/user/new',
                    name: 'CreerUtilisateur',
                    component: CreerUtilisateur,
                    meta: {
                        text: 'Nouvel utilisateur'
                    }
                },
                {
                    path: 'admin/user/:idStructure/new',
                    name: 'CreerUtilisateurStructure',
                    component: CreerUtilisateur,
                    meta: {
                        breadCrumbs: [{
                            to: '/pages/admin/structure/detail/:structureId',
                            text: ':structureNom'
                        }],
                        text: 'Nouvel utilisateur'
                    }
                },
                {
                    path: 'admin/listeUtilisateurs',
                    name: 'AdminListeUtilisateurs',
                    component: AdminListeUtilisateurs,
                    meta: {
                        text: 'Utilisateurs'
                    }
                },
                {
                    path: 'admin/listeLogs',
                    name: 'ListeLogs',
                    component: AdminListeLogs,
                    meta: {
                        text: 'Historique utilisateurs'
                    }
                },
                {
                    path: "*",
                    component: AccesUtilisateur,
                    meta: {
                        text: 'Accès'
                    }
                }
            ]
        }
    ]
})

// Check if user is registered

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      // this route requires auth, check if logged in
      // if not, redirect to login page.
      if (!localStorage.getItem('auth')) {
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        })
      } else {
        console.log('logged and pass to route')
        // si une route admin et que le user n'est pas admin redirect to acces
        const user = JSON.parse(localStorage.getItem('user'))
        if (to.path.includes('admin') && !user.admin) {
          next({ name: 'UserAcces' })
        } else {
          next()
        }
      }
    } else {
      console.log('not logged and pass to route')
      next() // make sure to always call next()!
    }
  })

export default router
